/**
 * 完了書（Completion Certificate）の型定義
 *
 * プレイヤーの推理スタイルを6角形レーダーチャートで可視化し、
 * AIが生成したネタバレなしの分析テキストを表示する機能
 */
/**
 * パラメータ計算に使うミニゲームテンプレートIDの分類
 */
export const MINIGAME_TEMPLATE_CATEGORIES = {
    /** 分析力: 暗号解読系 */
    analytical: [3, 4, 14],
    /** 観察力: 現場捜索系 */
    observation: [1, 2, 6],
    /** 推理力: 推理・矛盾系 */
    deduction: [11, 12, 13],
};
/**
 * パラメータの日本語ラベル
 */
export const CERTIFICATE_PARAM_LABELS = {
    analytical: '分析力',
    intuition: '直感力',
    persistence: '粘り強さ',
    observation: '観察力',
    communication: '対話力',
    deduction: '推理力',
};
/**
 * デフォルト証明書デザイン設定
 */
export const DEFAULT_CERTIFICATE_DESIGN = {
    theme: 'futuristic',
    radarChartStyle: 'gradient',
    evaluatorCommentStyle: {
        fontFamily: 'default',
        fontSize: 0.7,
        lineHeight: 1.7,
    },
    evaluatorDisplay: {
        showPortrait: false,
    },
};
// ============================================
// ユーティリティ定数・関数（UI共通）
// ============================================
/**
 * イースターエッグ判定閾値（100万以上で発動）
 */
export const EASTER_EGG_THRESHOLD = 1000000;
/**
 * エンディングタイプ別ラベル
 */
export const ENDING_TYPE_LABELS = {
    good: 'Good Ending',
    normal: 'Normal Ending',
    bad: 'Bad Ending',
    true: 'True Ending',
    secret: 'Secret Ending',
};
/**
 * エンディングタイプ別カラー
 */
export const ENDING_TYPE_COLORS = {
    good: '#22c55e',
    normal: '#3b82f6',
    bad: '#ef4444',
    true: '#eab308',
    secret: '#a855f7',
};
/**
 * フォントファミリーのCSSクラス名マッピング
 */
export const FONT_CLASS_MAP = {
    mincho: 'font-mincho',
    gothic: 'font-gothic',
    handwritten: 'font-handwritten',
};
/**
 * プレイ時間をフォーマット（ミリ秒 → 「X時間Y分」形式）
 */
export function formatPlayTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (hours > 0) {
        return `${hours}時間${minutes}分`;
    }
    return `${minutes}分`;
}
/**
 * エンディングタイプのラベルを取得
 */
export function getEndingTypeLabel(type) {
    if (!type)
        return 'Complete';
    return ENDING_TYPE_LABELS[type] ?? 'Complete';
}
/**
 * エンディングタイプのカラーを取得
 */
export function getEndingTypeColor(type) {
    if (!type)
        return '#8b5cf6';
    return ENDING_TYPE_COLORS[type] ?? '#8b5cf6';
}
//# sourceMappingURL=certificate.js.map